
import Loading from 'vux/src/components/loading/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import { getEvaluationCal } from 'api/evaluation'

export default {
components: {
Loading,
XHeader,
Group,
Flexbox,
FlexboxItem,
XButton,
Checker,
CheckerItem
},
data () {
return {
text: '加载中',
params: '',
title: '最低风险承受能力选择'
}
},
created () {
this.params = this.$route.query
},
methods: {
$_evaluation_confirm (type) {
this.params.isLowAccept = type
if (type === 1) {

let subdata = JSON.parse(this.params.subData)
subdata.afterResult = '风险承受最低类别'
getEvaluationCal(subdata, this.params.au).then((res) => {
if (res.code === 0) {
this.$router.push({path: '/evaluation/lastlowend', query: this.params})
}
})
return
}
this.$router.push({path: '/evaluation/lastlowend', query: this.params})
}








}
}



// WEBPACK FOOTER //
// ./src/components/Evaluation/lastLow.vue